// extracted by mini-css-extract-plugin
module.exports = {"root":"SortBy_root__cIZAS","select":"SortBy_select__hm0d9","label":"SortBy_label___dtWA"};